/* istanbul ignore file */
import { EqCondition, BaseFilterProps, useFilterContext } from 'framework/list';
import { FilterCondition } from 'framework/types';
import { useEffect, useState } from 'react';
import { InputLoader } from 'framework/ui/mui-builder';
import useAccountResourceService from '../accountResourceService';
import AccountInput from '../input/AccountNameInput';

const AccountFilter = ({ source, label, ...props }: BaseFilterProps) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [accountName, setAccountName] = useState(null);

  const { getValue } = useFilterContext();
  const { getById } = useAccountResourceService();

  const loadAccountAndInitializeLabel = async (accountId: StringOrNumber) => {
    const result = await getById(accountId);
    setAccountName(result.accountName);
    setIsInitialized(true);
  };

  useEffect(() => {
    const accountId = getValue(source, FilterCondition.EQ);

    if (accountId) {
      loadAccountAndInitializeLabel(accountId);
    } else {
      setIsInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isInitialized ? (
    <EqCondition {...props} source={source}>
      <AccountInput accountNameValue={accountName} label={label} />
    </EqCondition>
  ) : (
    <InputLoader />
  );
};

export default AccountFilter;
